export default "__VITE_ASSET__D8AOm8Xk__"